export function makeGrowerPath(path) {
  // eslint-disable-next-line no-underscore-dangle
  const store = window?.__REDUX_STORE__?.getState();
  const growerId = store?.growerOperations?.selectedGrowerOperation?.guid;

  if (!growerId) return path;

  return `/growers/${growerId}${path}`;
}
